import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import SupportDocs from 'components/SupportDocs';
import { LoaderButton } from 'ctia-ui';
import { saveRequest } from 'actions/request';
import { submitWizardStep } from 'actions/wizard';
import { startPreloader, finishPreloader } from 'actions/preloader';

class Documents extends Component {
  onSaveClick = () => {
    const { startPreloader, finishPreloader, saveRequest } = this.props;

    startPreloader();
    saveRequest(finishPreloader);
  };

  render() {
    const { show, request, canSubmit, wizard, user } = this.props;

    if (!show) return null;

    const isEditable = user.canUploadRequestDocs && request.id > 0;

    return (
      <div>
        <SupportDocs />
        <hr />
        <div className="text-right">
          <LoaderButton
            bsStyle="default"
            text="Save changes"
            isLoading={request.isLoading}
            onClick={this.onSaveClick}
            show={isEditable}
          />
          <LoaderButton
            bsStyle="success"
            text="Submit"
            isLoading={request.isLoading}
            onClick={() => this.props.submitWizardStep(wizard)}
            show={canSubmit}
          />
        </div>
      </div>
    );
  }
}

Documents.propTypes = {
  show: PropTypes.bool,
  canSubmit: PropTypes.bool,
  editMode: PropTypes.bool
};

Documents.defaultProps = {
  show: true,
  canSubmit: false,
  canSave: false
};

function mapStateToProps({ request, wizard, user }) {
  return { request, wizard, user };
}

export default connect(
  mapStateToProps,
  {
    saveRequest,
    submitWizardStep,
    startPreloader,
    finishPreloader
  }
)(Documents);



// WEBPACK FOOTER //
// ./src/containers/request/ECO/Steps/Vendor/Documents.js